import React, { createElement, Fragment } from 'react';
import classNames from 'classnames';
import Price from 'atomic/price';
import Link from 'atomic/link';
import Button from 'atomic/button';
import OfferInterface from 'interfaces/offer.interface';
import WidgetDSAInterface from 'modules/shared/widgets/interfaces/widgets-data/widget-dsa.interface';
import WidgetDSA from 'modules/shared/widgets/components/widget-dsa';
import { showDSA } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './product-best-offer.scss';

interface ProductBestOfferProps {
    title?: string;
    offer: OfferInterface | null;
    isMobile?: boolean;
    dsa?: WidgetDSAInterface;
}

const ProductBestOffer: React.FC<ProductBestOfferProps> = ({
    title,
    offer,
    dsa,
    isMobile = false
}) => {
    return offer
        ? (
            <Link
                className={classNames('best-offer sw gtm_or_chpst', {
                    'best-offer--mobile': isMobile
                })}
                rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                href={offer.url}
                target={LinkTarget.BLANK}
                title="Sklep z najlepszą ofertą"
            >
                <div className="best-offer__main">
                    {title && (
                        <div className="best-offer__wrapper">
                            <span className="label">
                                {title}
                            </span>
                            {dsa && showDSA(dsa) && (
                                <WidgetDSA
                                    dsa={dsa}
                                    size={10}
                                    color="gray"
                                />
                            )}
                        </div>
                    )}
                    <Price price={offer.price} fontSize={24} color="secondary"
                        weight={600}
                    />
                </div>
                {createElement(isMobile ? 'div' : Fragment, {}, (
                    <>
                        {offer.dealer.logo && (
                            <div className="best-offer__logo">
                                <img
                                    src={offer.dealer.logo}
                                    alt={offer.dealer.name}
                                    width={100}
                                    height={40}
                                />
                            </div>
                        )}
                        <Button
                            color="primary"
                            size={isMobile ? 'sm' : 'lg'}
                            className="best-offer__button"
                            tag="div"
                        >
                            Idź do sklepu
                        </Button>
                    </>
                ))}
            </Link>
        )
        : (
            <div className="best-offer__empty">
                Brak ofert dla tego produktu
            </div>
        );
};

export default ProductBestOffer;
